import { Form } from "semantic-ui-react";

const PersonalisationForm = ({ giftCardDetails, updateGiftCardProperty }) => {
  const { toName, toEmailAddress, fromName, message } = giftCardDetails;

  return (
    <>
      <div className='formContainer'>
        <Form>
          <h4 style={{ textAlign: 'left' }}>
            To:
          </h4>

          <Form.Field>
            <input
              placeholder="Recipient's name"
              type='text'
              autoComplete='off'
              onChange={ (e) => {
                updateGiftCardProperty('toName', e.target.value);
              }}
              value={ toName }
              className='neonInput'
              style={{
                border: '3px solid gray',
                fontSize: '16px'
              }}
            />
          </Form.Field>

          <Form.Field>
            <input
              placeholder="Recipient's email"
              type='email'
              autoComplete='off'
              onChange={ (e) => {
                updateGiftCardProperty('toEmailAddress', e.target.value);
              }}
              value={ toEmailAddress }
              className='neonInput'
              style={{
                border: '3px solid gray',
                fontSize: '16px'
              }}
            />
          </Form.Field>
        </Form>
      </div>

      <div className='formContainer'>
        <Form>
          <h4 style={{ textAlign: 'left' }}>
            From:
          </h4>
          <Form.Field>
            <input
              placeholder='Your name'
              type='text'
              autoComplete='given-name'
              onChange={ (e) => {
                updateGiftCardProperty('fromName', e.target.value);
              }}
              value={ fromName }
              className='neonInput'
              style={{
                border: '3px solid gray',
                fontSize: '16px'
              }}
            />
          </Form.Field>
          <textarea
            placeholder='Fancy including a message?'
            className='neonInput'
            style={{
              borderRadius: '3px',
              border: '3px solid gray',
              minWidth: '250px',
              width: '100%',
              minHeight: '100px',
              padding: '1em',
              fontSize: '16px',
              marginLeft: 'auto',
              marginRight: 'auto',
              fontFamily: "'Montserrat', sans-serif"
            }}
            value={message}
            onChange={(e) => updateGiftCardProperty('message', e.target.value)}
          />
        </Form>
      </div>

      <style jsx>{`
      .formContainer {
        margin: 1em;
        padding: 3em 2em;
        border-radius: 5px;
        box-shadow: 0 0 5px 2px lightgray;
        background-color: white;
        width: 100%;
        max-width: 400px;
      }
    `}</style>
    </>
  );
}

export default PersonalisationForm;